import { useEffect, useState } from 'preact/hooks';
import { platformNotifier, NotificationSummary } from './adminApi';
import { NotificationTable, NotificationDetailModal } from './OrgDetailPage';

export function NotificationsPage() {
  const [rows, setRows] = useState<NotificationSummary[]>([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [selected, setSelected] = useState<string | null>(null);

  const [typeFilter, setTypeFilter] = useState('');
  const [channelFilter, setChannelFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [recipientFilter, setRecipientFilter] = useState('');

  async function load() {
    setLoading(true);
    setErr(null);
    try {
      const r = await platformNotifier.query({
        notificationType: typeFilter.trim() || undefined,
        channel: channelFilter.trim() || undefined,
        status: statusFilter.trim() || undefined,
        recipientContains: recipientFilter.trim() || undefined,
        limit: 100,
      });
      setRows(r.rows || []);
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h1 style={{ marginTop: 0 }}>Notifications</h1>
      <p style={{ color: 'var(--admin-text-dim)' }}>
        Every outbound email and SMS the platform has tried to send, across all orgs.
        No redaction — click any row to view the full body (this view is audit-logged).
      </p>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          load();
        }}
        style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}
      >
        <input
          placeholder="Type (e.g. billing.*, auth.magic_link)"
          value={typeFilter}
          onInput={(e) => setTypeFilter((e.target as HTMLInputElement).value)}
          style={{ flex: 1, minWidth: 200 }}
        />
        <select
          value={channelFilter}
          onChange={(e) => setChannelFilter((e.target as HTMLSelectElement).value)}
          style={{ width: 120 }}
        >
          <option value="">All channels</option>
          <option value="email">Email</option>
          <option value="sms">SMS</option>
        </select>
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter((e.target as HTMLSelectElement).value)}
          style={{ width: 140 }}
        >
          <option value="">All statuses</option>
          <option value="pending">Pending</option>
          <option value="sent">Sent</option>
          <option value="failed">Failed</option>
        </select>
        <input
          placeholder="Recipient contains…"
          value={recipientFilter}
          onInput={(e) => setRecipientFilter((e.target as HTMLInputElement).value)}
          style={{ width: 220 }}
        />
        <button class="primary" type="submit" disabled={loading}>
          Apply
        </button>
      </form>

      {err && <div class="error-banner">{err}</div>}

      <NotificationTable rows={rows} onOpen={setSelected} />

      {!loading && rows.length === 0 && (
        <p style={{ color: 'var(--admin-text-dim)' }}>
          No notifications match. Nothing has been emitted through the LoggingNotifier yet, or filters exclude all rows.
        </p>
      )}

      {selected && <NotificationDetailModal id={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
